<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>

<mat-card fxLayout="column">
    <mat-error *ngIf="extUserFormGroup.value.isVerified === 0">The EIN was not found from Guidestar or Exception List.
        Please double check organization information before further decision.</mat-error>
    <br>
    <mat-accordion>
        <mat-expansion-panel hideToggle expanded='true'>
            <mat-expansion-panel-header>
                <mat-card-subtitle>
                    <b>User Information</b>
                </mat-card-subtitle>
            </mat-expansion-panel-header>
            <form [formGroup]="extUserFormGroup" class="content" fxLayout="column" fxLayout.sm="column"
                fxLayout.xs="column" fxLayoutGap="16px">
                <mat-form-field>
                    <input type="text" matInput placeholder="First Name" maxlength="150" formControlName="firstName"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Last Name" maxlength="150" formControlName="lastName"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="email" matInput placeholder="Email Address" maxlength="254" formControlName="email"
                        readonly>
                </mat-form-field>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
    <br>
    <mat-accordion>
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-card-subtitle [ngStyle]="{'color': extUserFormGroup.value.isVerified === 0? 'red': 'black'}">
                    <b>Organization Information</b>
                </mat-card-subtitle>
            </mat-expansion-panel-header>
            <form [formGroup]="extOrgInfoFormGroup" class="content" fxLayout="column" fxLayout.sm="column"
                fxLayout.xs="column" fxLayoutGap="16px">
                <mat-form-field>
                    <input type="text" matInput placeholder="Organization Name" maxlength="50" formControlName="name"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="EIN" maxlength="10" formControlName="EIN" readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Tax-Exempt Status" maxlength="15"
                        [value]="getTaxExemptStatus(extOrgInfoFormGroup.value.subsection_501)" readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Web Address" maxlength="250" formControlName="webAddress"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Address1" maxlength="35" formControlName="address1"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Address2" maxlength="35" formControlName="address2"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="City" maxlength="50" formControlName="city" readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="State" maxlength="50" formControlName="state" readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Zip Code" maxlength="9" formControlName="zipCode" readonly>
                </mat-form-field>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
    <br>
    <mat-accordion>
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-card-subtitle>
                    <b>Contact Information</b>
                </mat-card-subtitle>
            </mat-expansion-panel-header>
            <form [formGroup]="extOrgContactInfoFormGroup" class="content" fxLayout="column" fxLayout.sm="column"
                fxLayout.xs="column" fxLayoutGap="16px">
                <mat-form-field>
                    <input type="text" matInput placeholder="President/CEO/Executive Director" maxlength="150"
                        formControlName="title" readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="First Name" maxlength="150" formControlName="firstName"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" matInput placeholder="Last Name" maxlength="150" formControlName="lastName"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" phone matInput placeholder="Phone Number" maxlength="12" formControlName="phone"
                        readonly>
                </mat-form-field>
                <mat-form-field>
                    <input type="email" matInput placeholder="Email Address" maxlength="254" formControlName="email"
                        readonly>
                </mat-form-field>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</mat-card>
<div class="buttons" fxLayout="row" fxLayoutGap="20px" static fxLayoutAlign="center center">
    <button mat-raised-button color="warn" (click)="onClose()">Close</button>
    <button mat-raised-button color="warn" (click)="onReject()"
        *ngIf="extUserFormGroup.value.accessStatus?.includes('pending') && isApproving">Reject</button>
    <button mat-raised-button color="primary" (click)="onApprove()"
        *ngIf="extUserFormGroup.value.accessStatus?.includes('pending') && isApproving">Approve</button>
</div>